export enum FileType {
  Excel = "Excel",
  None = "None",
  OneNote = "OneNote",
  PowerPoint = "PowerPoint",
  Visio = "Visio",
  Word = "Word",
}
